import React from "react";
import axios from "axios";
import Modal from "../../Common/Modal";
import validator from "validator";
import logo from "./teamX_Logo-01.png";

class Start extends React.Component {
  state = {
    name: "",
    email: "",
    message: "",
    clicked: false,
    error: ""
  };

  handleInput = event => {
    let name = event.target.name;
    this.setState({ [name]: event.target.value });
  };

  handleSubmit = () => {
    console.log("hello");
    let validated = false;
    for (var prop in this.state) {
      if (this.state.name.length < 2) {
        this.setState({ error: "name must be at least 2 characters" });
        return;
      } else {
        this.setState({ error: "" });
      }
      if (!validator.isEmail(this.state.email)) {
        this.setState({ error: "email must be valid" });
        return;
      } else {
        this.setState({ error: "" });
      }
      if (this.state.message.length < 2) {
        this.setState({ error: "you must send a message" });
        return;
      } else {
        this.setState({ error: "" });
      }
    }
    if (this.state.error === "") {
      validated = true;
    } else {
      validated = false;
    }
    if (validated) {
      const newEmail = {
        name: this.state.name,
        email: this.state.email,
        message: this.state.message
      };
      this.setState({ name: "", email: "", message: "", clicked: true });
      axios.post("/api/newMessage/", newEmail).then(response => {
        axios
          .post("/api/sendMessage", {
            email: newEmail.email,
            name: newEmail.name
          })
          .then(res => console.log(res));
      });
    }
  };

  changeStateToFalse = () => {
    this.setState({ clicked: false });
  };

  render() {
    return (
      <div id="contact">
        <div className="bg-image" />
        <Modal
          status={this.state.clicked}
          changeState={this.changeStateToFalse}
        />
        <div className="px-2 py-5 mt-1" id="contactContainer">
          <div className="row">
            <div className="col-md-6">
              <div className="contact-us-header">
                Let's Make Something Awesome Together
              </div>
              <p>Drop us a line, we would love to learn about your projects.</p>

              <div id="quote" className=" pb-4">
                "Helping our clients achieve their goals is what drives us… It’s
                what makes us TeamX."
                <br />
                <span id="brad">- Brad Bahmanpour, Founder | CEO</span>
              </div>
            </div>
            <div id="contactBox" className="col-md-6">
              <div className="contact-us">Contact Us</div>
              <label style={{ color: "red", fontSize: "10px" }} htmlFor="name">
                {this.state.error.includes("name")
                  ? "name must be valid"
                  : null}
              </label>
              <input
                className="px-2"
                type="text"
                id="name"
                name="name"
                value={this.state.name}
                style={
                  this.state.error.includes("name")
                    ? { border: "solid 1px red" }
                    : null
                }
                placeholder={
                  this.state.error.includes("name")
                    ? this.state.error
                    : "your full name"
                }
                onChange={this.handleInput}
              />

              <label style={{ color: "red", fontSize: "10px" }} htmlFor="email">
                {this.state.error.includes("email")
                  ? "email must be valid"
                  : null}
              </label>
              <input
                className="px-2"
                type="text"
                id="email"
                name="email"
                placeholder={
                  this.state.error.includes("email")
                    ? this.state.error
                    : "your email address"
                }
                style={
                  this.state.error.includes("email")
                    ? { border: "solid 1px red" }
                    : null
                }
                value={this.state.email}
                onChange={this.handleInput}
              />
              <label
                style={{ color: "red", fontSize: "10px" }}
                htmlFor="message"
              >
                {this.state.error.includes("message")
                  ? "message must be valid"
                  : null}
              </label>
              <textarea
                className="px-2"
                id="message"
                name="message"
                placeholder={
                  this.state.error.includes("message")
                    ? this.state.error
                    : "your message"
                }
                value={this.state.message}
                style={
                  this.state.error.includes("message")
                    ? { border: "solid 1px red" }
                    : null
                }
                onChange={this.handleInput}
              />

              <button
                id="submitBtn"
                type="submit"
                onClick={() => {
                  this.handleSubmit();
                }}
              >
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Start;



// WEBPACK FOOTER //
// ./src/components/Services/Start/Start.js